// @services/ReportedReview/GetReportedReviewsService.ts
import ScrubstrApiQueryService from '../ScrubstrApiQueryService/ScrubstrApiQueryService'

// DTO types
export interface ReviewAnswer {
  id: number
  value: string
  question: string
  type?: string // e.g., "select", "radio", etc.
}

export interface ReportedReview {
  id: number
  email: string
  createdAt: string
  answers: ReviewAnswer[]
  category?: 'hospital' | 'agency'
  organizationName?: string
  organizationType?: 'hospital' | 'agency'
  organizationId?: number
}

export class ReportedReviewByAdminService {
  async getReportedReviews(): Promise<ReportedReview[]> {
    const api = new ScrubstrApiQueryService()

    // call the API - axios already parses JSON, so response is the array directly
    const data = await api.get<ReportedReview[]>({
      endpoint: 'admin/reviews/reported-reviews',
    })

    // Ensure we return an array
    return Array.isArray(data) ? data : []
  }
}
